const API_KEY = process.env.REACT_APP_API_KEY;

const API_BASE = 'https://api.themoviedb.org/3';

const basicFetch = async (endpoint) => {
  const req = await fetch(`${API_BASE}${endpoint}`);
  const json = await req.json();
  return json;
}

const api = {
  getHomeList: async () => {
    return [
      {
        slug: 'originals',
        title: 'Originais da Netflix',
        items: await basicFetch(`/discover/tv?with_networks=213&language=pt-BR&api_key=${API_KEY}`)
      },
      {
        slug: 'trending',
        title: 'Em Alta',
        items: await basicFetch(`/trending/tv/week?language=pt-BR&api_key=${API_KEY}`)
      },
      {
        slug: 'toprated',
        title: 'Melhores Avaliados',
        items: await basicFetch(`/tv/top_rated?language=pt-BR&api_key=${API_KEY}`)
      },
      {
        slug: 'drama',
        title: 'Drama',
        items: await basicFetch(`/discover/tv?with_genres=18&language=pt-BR&api_key=${API_KEY}`)
      },
      {
        slug: 'comedy',
        title: 'Comédia',
        items: await basicFetch(`/discover/tv?with_genres=35&language=pt-BR&api_key=${API_KEY}`)
      },
      {
        slug: 'crime',
        title: 'Crime',
        items: await basicFetch(`/discover/tv?with_genres=80&language=pt-BR&api_key=${API_KEY}`)
      },
      {
        slug: 'action',
        title: 'Ação',
        items: await basicFetch(`/discover/tv?with_genres=10759&language=pt-BR&api_key=${API_KEY}`)
      },
      {
        slug: 'family',
        title: 'Família',
        items: await basicFetch(`/discover/tv?with_genres=10751&language=pt-BR&api_key=${API_KEY}`)
      },
    ];
  },
  getMovieInfo: async (movieId, type) => {
    let info = {};

      if(movieId) {
        switch(type) {
          case 'movie':
            info = await basicFetch(`/movie/${movieId}?language=pt-BR&api_key=${API_KEY}`);
          break;
          case 'tv':
            info = await basicFetch(`/tv/${movieId}?language=pt-BR&api_key=${API_KEY}`);
          break;
          default:
            info = null;
          break;
        }
      }
    return info;
  }
}

export default api;